<template>
    <modal :show="show" :large="true" v-on:update:show="handleModalClose">
        <template slot="header">
            <h5 class="modal-title">
                {{ number.tag ? number.tag + ' (' + number.formatted_did + ')': number.formatted_did
                }}'s Call Flow</h5>
        </template>

        <template>

        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('update:show', false)">Close</base-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import BaseSwitch from "../../components/BaseSwitch";
    import {mapFields} from "vuex-map-fields";
    import draggable from 'vuedraggable';
    import {Collapse, CollapseItem} from '../../components'
    import QueueSelector from "../../components/Queue/QueueSelector";
    import IVRSelector from "../../components/IVR/IVRSelector";
    import PhoneNumberSelector from "./PhoneNumberSelector";
    import SIPDeviceSelector from "../SIPDevices/SIPDeviceSelector";
    import RinggroupSelector from "../Ringgroup/RinggroupSelector";
    import Sortable from 'sortablejs';


    export default {
        name: "CallflowModal",
        components: {
            RinggroupSelector,
            SIPDeviceSelector,
            PhoneNumberSelector,
            IVRSelector,
            QueueSelector,
            Modal,
            BaseSwitch,
            draggable,
            Collapse,
            CollapseItem
        },
        props: {
            number: {},
            show: Boolean,
        },
        data() {
            return {
                saving: false,
                isLoading: false,
                drag: false,
                timecondition: null,
                ringgroup: null,
                destinations: [{
                    type: 'ringgroup',
                    ringgroup: null,
                    devices: {
                        enabled: true,
                        data: []
                    },
                    numbers: {
                        enabled: true,
                        data: ['+99']
                    },
                    timeout: 30,
                    ivr: null,
                    queue: null,
                },
                    {
                        type: 'ringgroup',
                        ringgroup: null,
                        devices: {
                            enabled: true,
                            data: []
                        },
                        numbers: {
                            enabled: true,
                            data: ['+99']
                        },
                        timeout: 30,
                        ivr: null,
                        queue: null,
                    }],
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            ...mapFields(`timecondition`, ['timeconditions']),
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            }
            ,
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.updateSettings()
                    }
                })
            },
            handleModalClose(value) {
                this.$emit('update:show', value);
            },
            loadTimeconditions() {
                this.isLoading = true;

                this.$store.dispatch('timecondition/load').then(() => {
                    this.isLoading = false;
                });
            },
            querySearch(queryString, cb) {
                let results = queryString ? this.timeconditions.filter(this.createFilter(queryString)).map(s => {
                    return {name: s.name, value: s.id, active: s.is_active}
                }) : this.timeconditions.map(s => {
                    return {name: s.name, value: s.value, active: s.is_active}
                });
                cb(results);
            },
            createFilter(queryString) {
                return (timecondition) => {
                    return (timecondition.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
        },
        mounted() {
            if (this.$store.getters['timecondition/needUpdate']) {
                this.loadTimeconditions();
            }
            var el = document.getElementById('timeline');

            Sortable.create(el, { /* options */});

        },
        watch: {
            // whenever sipdevice changes, this function will run
            number: function (newNumber, oldNumber) {
                if (this.number != null) {
                    this.$emit('update:show', true)
                }
            },
        },
    }
</script>

<style scoped>
    .modal-dialog {
        overflow-y: initial !important
    }

    .modal-body {
        height: 250px;
        overflow-y: auto;
    }

    .m-r-20 {
        margin-right: 20px;
    }

    .p-t-15 {
        padding-top: 15px;
    }

    .relative {
        position: relative;
    }

    .timeline {
        position: relative;
        margin: 50px;
        padding: 0;
        list-style: none;
        counter-reset: section;
    }

    .timeline:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 3px;
        background: #fdb839;
        left: 32px;
        margin: 0;
        border-radius: 2px;
    }

    .timeline > li {
        position: relative;
        margin-right: 10px;
        margin-bottom: 50px;
        padding-top: 18px;
        box-sizing: border-box;
    }

    .timeline > li:before,
    .timeline > li:after {
        display: block;
    }

    .ui-sortable-helper {
        box-shadow: 0px 0px 41px rgba(0, 0, 0, 0.08);
        background: #fff;
    }

    .ui-sortable-helper .handle {
        display: none;
    }

    .timeline > li:not(.ui-sortable-helper):before {
        counter-increment: section;
        content: counter(section);
        background: #fdb839;
        width: 70px;
        height: 70px;
        position: absolute;
        top: 0;
        border-radius: 50%;
        left: -1px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #Fff;
        font-size: 22px;
        font-weight: bold;
        border: 15px solid #fff;
        box-sizing: border-box;
    }

    .timeline > li:after {
        clear: both;
    }

    .timeline > li > .timeline-item {
        margin-top: 0;
        color: #444;
        margin-left: 60px;
        margin-right: 15px;
        padding: 0;
    }

    .timeline > li > .fa,
    .timeline > li > .glyphicon,
    .timeline > li > .ion {
        width: 30px;
        height: 30px;
        font-size: 15px;
        line-height: 30px;
        position: absolute;
        color: #fff;
        background: #fdb839;
        border-radius: 50%;
        text-align: center;
        left: 18px;
        top: 0;
    }

    .radio-thumbnail > label {
        border-radius: 4px;
    }

    .radio-thumbnail > input {
        display: none;
    }

    .radio-thumbnail > :checked + .thumbnail {
        border: 4px solid #21BB05;
        border-radius: 4px;
    }

    .radio-thumbnail > :checked + .thumbnail > span {
        border-radius: 0;
    }

    .radio-thumbnail > :disabled + .thumbnail {
        opacity: .5;
    }

    .radio-thumbnail > :checked + .thumbnail:before {
        content: "\f00c";
        font-family: fontawesome;
        position: absolute;
        top: -10px;
        right: -10px;
        font-size: 15px;
        z-index: 1;
        color: #fff;
        background: #21bb05;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.3s all;
    }

    .thumbnail {
        padding: 0;
        margin: 0;
        width: 192px;
        height: 140px;
        border: 0;
        position: relative;
    }

    .thumbnail > span {
        position: absolute;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.65+100 */
        background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#a6000000', GradientType=0);
        /* IE6-9 */
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 20px;
        font-weight: 400;
        padding: 97px 0 0 16px;
        text-align: left;
        border-radius: 4px;
        border: 0;
    }

    .uxc__f-tags .btn.btn-default {
        border-color: #fdb839;
        background: transparent;
        color: #fdb839;
    }

    .uxc__f-tags .btn {
        margin-right: 15px;
    }

    .uxc__f-tags .btn.btn-default:hover,
    .uxc__f-tags .btn.btn-default:focus,
    .uxc__f-tags .btn.btn-default:active,
    .uxc__f-tags .btn.btn-default.active {
        border-color: #fdb839;
        background: #fdb839;
        color: #fff;
        box-shadow: 0px 0px 0px;
        transition: all 0.3s;
    }

    label.btn.btn-default.active:before {
        content: "\f00c";
        font-family: fontawesome;
        position: absolute;
        top: 7px;
        right: -10px;
        font-size: 13px;
        z-index: 1;
        color: #fff;
        background: #21bb05;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.3s all;
    }

    .f-cancel {
        position: absolute;
        top: 0;
        right: 0;
        color: #ABABAB;
        border: 1px solid #ABABAB;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s;
    }

    .f-cancel:hover {
        border-color: #fdb839;
        color: #fdb839;
        cursor: pointer;
    }

    .add-n-f {
        padding: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px dotted #989898;
        color: #989898;
        border-radius: 4px;
        margin: 0 30px 0 77px;
        transition: all 0.3s;
        cursor: pointer;
    }

    .add-n-f i {
        border: 1px dotted #989898;
        width: 25px;
        height: 25px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }

    .add-n-f:hover {
        border-color: #fdb839;
        color: #fdb839;
    }

    .add-n-f:hover i {
        color: #fdb839;
        border-color: #fdb839;
    }

    .handle {
        color: #000;
        cursor: move;
        left: -8px;
        width: 13px;
        height: 40px;
        position: absolute;
        top: 16px;
        background-image: -webkit-repeating-radial-gradient(center center, rgba(0, 0, 0, 0.26), rgba(0, 0, 0, 0.23) 1px, transparent 1px, transparent 100%);
        background-image: -moz-repeating-radial-gradient(center center, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2) 1px, transparent 1px, transparent 100%);
        background-image: -ms-repeating-radial-gradient(center center, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2) 1px, transparent 1px, transparent 100%);
        background-image: repeating-radial-gradient(center center, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2) 1px, transparent 1px, transparent 100%);
        -webkit-background-size: 3px 3px;
        -moz-background-size: 3px 3px;
        background-size: 3px 3px;
    }

    .timeline-placeholder {
        height: 150px;
        border: 2px dashed #ddd;
        left: 71px;
        top: -2px;
    }

    .timeline-placeholder:before {
        left: -75px !important;
    }

    .timeline-placeholder:after {
        content: "Drop it here";
        text-align: center;
        top: 23px;
        position: relative;
        font-size: 39px;
        color: rgba(221, 221, 221, 0.38);
    }

    #sortable {
        list-style-type: none;
        margin: 0;
        padding: 0;
        width: 60%;
    }

    #sortable li {
        margin: 0 3px 3px 3px;
        padding: 0.4em;
        padding-left: 1.5em;
        font-size: 1.4em;
        height: 18px;
    }

    #sortable li span {
        position: absolute;
        margin-left: -1.3em;
    }


    /*=================================================================
    Override Bootstrap Tabs
    ==================================================================*/

    /* Tabs panel */
    .tabbable-panel {
        padding: 10px;
    }

    .tabbable-line > .nav-tabs {
        border: none;
        margin: 0px;
        display: flex;
        justify-content: space-between;
    }

    .tabbable-line > .nav-tabs > li {
        margin: 0px 2px 2px 0;
        transition: 0.5s ease;
    }

    .tabbable-line > .nav-tabs > li > a {
        border: 0;
        margin-right: 0;
        color: #A9A9A9;
        padding: 4px 0px;
    }

    .tabbable-line > .nav-tabs > li > a > i {
        color: #a6a6a6;
    }

    .tabbable-line > .nav-tabs > li.open, .tabbable-line > .nav-tabs > li:hover {
        border-bottom: 4px solid @warning-dark;
    }

    .tabbable-line > .nav-tabs > li.open > a, .tabbable-line > .nav-tabs > li:hover > a {
        border: 0;
        background: none !important;
        color: #333333;
    }

    .tabbable-line > .nav-tabs > li.open > a > i, .tabbable-line > .nav-tabs > li:hover > a > i {
        color: #a6a6a6;
    }

    .tabbable-line > .nav-tabs > li.open .dropdown-menu, .tabbable-line > .nav-tabs > li:hover .dropdown-menu {
        margin-top: 0px;
    }

    .tabbable-line > .nav-tabs > li.active {
        border-bottom: 4px solid #fdb839;
        position: relative;
        transition: 0.5s ease;
    }

    .tabbable-line > .nav-tabs > li.active > a {
        border: 0;
        color: #333333;
    }

    .tabbable-line > .nav-tabs > li.active > a > i {
        color: #404040;
    }

    .tabbable-line > .tab-content {
        margin-top: -3px;
        background-color: #fff;
        border: 0;
        border-top: 1px solid #eee;
        padding: 15px 0;
    }

    .portlet .tabbable-line > .tab-content {
        padding-bottom: 0;
    }
</style>